/**
 * 受講生の声の節の「投稿の壁」(VoiceWall.tsx) に並べる、受講生の note の学習記録。
 * X の投稿 (voice-posts.ts の VOICE_POSTS) と同じ壁に混ぜて、2 段で横に流す。
 *
 * 2026-10-21 に代表が、受講生が公開している X と note の投稿は、本人に 1 件ずつ聞かなくても HP に載せてよいと決めた。
 * ここには、ハッシュタグ #ゆめさくエンジニア の note 31 件から運営の 2 アカウントの 9 件を除いた、受講生 5 人の 22 件を入れてある。
 * 取得と受講生かどうかの確認は notes-sandbox/ops/scratch/2026-10-21/voice-wall/candidates.md に残してある。
 * X と note が両方 0 件に戻れば壁ごと消える (VoiceWall が長さ 0 を見て何も描かない)。
 *
 * 足し方
 *  1. 受講生本人が公開している記事だけを足す。運営のアカウントの記事は足さない
 *  2. 下の VOICE_NOTES に 1 件足す。url は記事の URL そのまま (https://note.com/<書いた人>/n/<記事キー>)
 *  3. title と author は note に出ている題と表示名そのまま。本名と顔写真は足さない
 *  4. excerpt は本文の冒頭から原文のまま切り出す (言い回しを直さない。段落の区切りは改行のまま。切るのは文か行の終わりだけ。70〜150 字ほど)
 *  5. avatar は note のアイコン (https://note.com/api/v2/creators/<書いた人> の profileImageUrl)。
 *     assets.st-note.com のものか、アイコン未設定の既定の絵 (d2l930y2yx77uc.cloudfront.net)。どちらも CSP の img-src に許可済み
 *  6. 外すときは、その 1 件を消す
 *
 * 並べ方は配列の順。X の投稿 (voice-posts.ts) と混ぜた壁では、X と note を 1 件ずつ交互に置いて 0,1,1,0 の順で段に配るので、
 * 配列の順はその配り方で同じ書き手が隣り合わないように組んである (X の書き手も同じ人として数える)。壁は単独の出どころのとき 1 件おきに上と下の段へ配るので、偶数番目が上の段、奇数番目が下の段になる。
 * 段は輪になって流れるので、同じ書き手が段の中で隣り合わないように (段の末尾と先頭も) 並べてある。足すときも崩さない。
 */
export type VoiceNote = {
  /** 記事の URL */
  url: string;
  /** note に出ている題 */
  title: string;
  /** 本文の冒頭の原文。改行もそのまま */
  excerpt: string;
  /** 公開日。YYYY-MM-DD */
  date: string;
  /** note の表示名そのまま (「さん」は付けない) */
  author: string;
  /** アイコンの URL。assets.st-note.com か d2l930y2yx77uc.cloudfront.net のもの */
  avatar?: string;
};

export const VOICE_NOTES: VoiceNote[] = [
  {
    url: "https://note.com/ferret_7/n/n7813683d7add",
    title: "ゆめさくエンジニア_学習記録（2）",
    excerpt: "いかんせん基本のきの字もわからないからスタートラインに立つまでの学びが多すぎる…先月分に入りきらなかったことをまとめます\n生成AIの仕組みとプロンプトエンジニアリング",
    date: "2026-10-01",
    author: "ポテト",
    avatar: "https://assets.st-note.com/production/uploads/images/316951277/profile_d73f2f490b0ddbe0ea55bc0b0fe0b11c.jpg?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/happy_rabbit8685/n/n9a4dbb893adc",
    title: "ゆめさく学習記録_Level 2（学習発表会編）",
    excerpt: "ごきげんよう〜。\n早いもので学習スタートしてから1ヵ月が経過しようとしています。\nnoteやXで学習記録を発信し始めてからコメントをいただくこともあり、それらが学習の励みになっています。改めて、コメント・フォローいただいた皆様ありがとうございます！",
    date: "2026-09-27",
    author: "YuRicode",
    avatar: "https://assets.st-note.com/poc-image/manual/preset_user_image/production/ic3fd94079689.jpg",
  },
  {
    url: "https://note.com/charm_human5091/n/nb498498a0c7e",
    title: "「ゆめさくエンジニア」受講記録 vol.３　　葬儀屋からエンジニアを目指す学習記録　~４ヶ月目~",
    excerpt: "今月取り組んだ学習内容について以下にまとめます。\n１、コンピュータサイエンス基礎\n・データベース（DB)の役割\n構造化されたデーターの管理、検索、保管 すぐに目的のデータが探せるように管理されていて、複雑な問いにも対応できます。",
    date: "2026-09-28",
    author: "koba",
    avatar: "https://d2l930y2yx77uc.cloudfront.net/assets/default/default_profile_4-e3b57528da29acad20d5a2db33268c87f1d39015448757ddf346d60fb5861e49.png",
  },
  {
    url: "https://note.com/sachiura1203/n/n2b7cb2687a6d",
    title: "ゆめさくエンジニア　定例発表会3回目",
    excerpt: "9月の定例発表会の内容です。\n今回はデータベース作成に向けた前段階の発表です。\n今回は、「おさるのジョージ図書館のデータベース設計」というテーマで発表します。",
    date: "2026-09-26",
    author: "うら",
    avatar: "https://assets.st-note.com/production/uploads/images/308257244/profile_f19b8f25d0e34c58837049527ba4b301.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/sachiura1203/n/n946b1797fa57",
    title: "SQL・DB学習つまずきポイント集",
    excerpt: "SQL・データベースの学習で、実際に演習をやっていてつまずいたところをまとめました。\nSQL\nNULLの条件\nNULL は = では比較できない。",
    date: "2026-09-26",
    author: "うら",
    avatar: "https://assets.st-note.com/production/uploads/images/308257244/profile_f19b8f25d0e34c58837049527ba4b301.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/ferret_7/n/n271774d68476",
    title: "ゆめさくエンジニア_学習記録（１）",
    excerpt: "ゆめさくエンジニアに入会して1か月経過したので取り組みと苦労したことを記録。勉強中のため間違えてることも多々ありますがご容赦ください。",
    date: "2026-09-25",
    author: "ポテト",
    avatar: "https://assets.st-note.com/production/uploads/images/316951277/profile_d73f2f490b0ddbe0ea55bc0b0fe0b11c.jpg?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/happy_rabbit8685/n/n4f43b9535ea2",
    title: "はじめに＆ゆめさく学習記録_Level.1",
    excerpt: "はじめに\nはじめまして、YuRicodeです。\n現在は都内のIT企業に勤めながら英語とスペイン語の勉強をしつつ、ITエンジニアを目指しています。",
    date: "2026-09-12",
    author: "YuRicode",
    avatar: "https://assets.st-note.com/poc-image/manual/preset_user_image/production/ic3fd94079689.jpg",
  },
  {
    url: "https://note.com/charm_human5091/n/ndd9336b2059c",
    title: "「ゆめさくエンジニア」受講記録 vol.2 　　葬儀屋からエンジニアを目指す学習記録　~3ヶ月目~",
    excerpt: "1、私事ではありますが\n現在、私は葬儀屋として働いています。夏場ということもあり、業務は日に日に忙しさを増しています。そんな折、私生活では結婚式の準備も並行して進めており、気づけば本番はもう来週に迫ってきました。",
    date: "2026-09-08",
    author: "koba",
    avatar: "https://d2l930y2yx77uc.cloudfront.net/assets/default/default_profile_4-e3b57528da29acad20d5a2db33268c87f1d39015448757ddf346d60fb5861e49.png",
  },
  {
    url: "https://note.com/clever_cobra2626/n/n75c9afa33e57",
    title: "ゆめさくエンジニアでの学習記録(Vol.9)",
    excerpt: "はじめに\n今回は、ゆめさくエンジニアの月末行事の学習発表会にて発表した内容を紹介します。\nzoomでの発表\nポモドーロタイマー作成の軌跡",
    date: "2026-08-30",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/n097683b1acd5",
    title: "ゆめさくエンジニアでの学習記録(Vol.8)",
    excerpt: "はじめに\nITの勉強を通して学んだことを、生成AIに頼らずに、自分の言葉でアウトプットして理解を深めるために投稿しています。",
    date: "2026-07-27",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/n3dea3931e5a6",
    title: "ゆめさくエンジニアでの学習記録 (Vol.7)",
    excerpt: "はじめに\nITの勉強を通して学んだことを、生成AIに頼らずに、自分の言葉でアウトプットして理解を深めるために投稿しています。26/7/6に加筆修正しています。",
    date: "2026-07-05",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/n546357505899",
    title: "ゆめさくエンジニアでの学習記録(Vol.6)",
    excerpt: "これも勉強です！！\n日曜日の夜、早めに家事も終わったのでいざIT勉強の宿題を提出しようとmattermostを開いたところ、真っ白の画面になっていることが判明。",
    date: "2026-06-21",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/n71c7c0ebe380",
    title: "ゆめさくエンジニアでの学習記録(Vol.5)",
    excerpt: "SSL/TLS通信とは何か？\nSSL/TLS通信は、通信を暗号化するためのプロトコルで、昔はSSL方式を使っていたが、今は改良されたTLS方式が主流である。昔からSSLという名前が一般的だったために、今でもその名称だけ残っている。",
    date: "2026-06-20",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/n495a2cac85c8",
    title: "ゆめさくエンジニアでの学習記録 (Vol.4)",
    excerpt: "インクリメントとデクリメントについて理解できたので、アウトプットしてみた\nインクリメントとデクリメントはJavaでコードを書くうえで、コードを簡略化する手法の一つ。",
    date: "2026-05-15",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/sachiura1203/n/n1d6b57412eab",
    title: "『ゆめさくエンジニア』定例発表会　2回目",
    excerpt: "今月はタッチ決済の安全性について調べてみました。\n調べようと思ったきっかけが私自身現金を使わないことが増えてきて、クレジットカードを使う機会が多くなりました。",
    date: "2026-08-29",
    author: "うら",
    avatar: "https://assets.st-note.com/production/uploads/images/308257244/profile_f19b8f25d0e34c58837049527ba4b301.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/sachiura1203/n/n0c0ae32d21a4",
    title: "『ゆめさくエンジニア』定例発表会　1回目",
    excerpt: "私が現在学んでいるゆめさくエンジニアでは月に1回発表会があります。\n内容は気になったことを調べてみたり、何か作ってみたらそれを見せたりと様々です。",
    date: "2026-08-29",
    author: "うら",
    avatar: "https://assets.st-note.com/production/uploads/images/308257244/profile_f19b8f25d0e34c58837049527ba4b301.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/ndc7c753f7548",
    title: "ゆめさくエンジニアでの学習記録 (Vol.3)",
    excerpt: "ChatGPTと一緒に「点→線→面」で理解が変わった話\nなんとなくの理解から全体像を理解をするのが大事では、インターネットの理解をchatGTPに添削してもらった経緯をまとめました。",
    date: "2026-04-14",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/n70cf736ad7d8",
    title: "場所を選ばず、自分らしく。子どもに「広い世界」を見せるためのアップデート記録",
    excerpt: "すでにいくつか記事を投稿していますが、これが初めての方もいらっしゃると思うので、改めて自己紹介をさせてください。",
    date: "2026-04-11",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/sachiura1203/n/ne82d082c9465",
    title: "『ゆめさくエンジニア』　CS データベースまとめ",
    excerpt: "今回はデータベースについて学習内容をまとめました。\nデータベースとは？\n複数のプログラムやユーザーから共有して使えるよう構造化して保存されたデータの集合体。",
    date: "2026-08-27",
    author: "うら",
    avatar: "https://assets.st-note.com/production/uploads/images/308257244/profile_f19b8f25d0e34c58837049527ba4b301.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/charm_human5091/n/nba274f42318f",
    title: "「ゆめさくエンジニア」受講記録 vol.1 　　葬儀屋からエンジニアを目指す学習記録　~1ヶ月目~",
    excerpt: "1. はじめに(自己紹介・背景)\nはじめまして。\n私は現在、葬儀関係の仕事についておりますが、未経験からWebエンジニアを目指して学習を始めています！",
    date: "2026-07-06",
    author: "koba",
    avatar: "https://d2l930y2yx77uc.cloudfront.net/assets/default/default_profile_4-e3b57528da29acad20d5a2db33268c87f1d39015448757ddf346d60fb5861e49.png",
  },
  {
    url: "https://note.com/clever_cobra2626/n/nbb5a209ec781",
    title: "ゆめさくエンジニアでの学習記録 (Vol.2)",
    excerpt: "はじめに\n2児を育てる技術職。将来の在宅エンジニア転職と、AIを使いこなす人材への成長を目指しています。現状の業務効率化を図りつつ、「自分だけの武器」を手に入れるための確かな学習ステップをここに記録します。",
    date: "2026-04-09",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
  {
    url: "https://note.com/clever_cobra2626/n/ndce87b7f03e9",
    title: "ゆめさくエンジニアでの学習記録(Vol.1)",
    excerpt: "はじめに\n初めまして。現在、技術開発の現場で残業もしながら、2人の男の子を育てている母です。\n私が今、エンジニアという新しいキャリアを目指しているのは、**「AIに使われるのではなく、AIを使いこなせる側の人材」**になりたいから。",
    date: "2026-03-22",
    author: "なべ",
    avatar: "https://assets.st-note.com/production/uploads/images/266483913/profile_8bbc49cf5742800e72b780f581d9826e.png?fit=bounds&format=jpeg&quality=85&width=330",
  },
];
